import { initializeFeedbackAccordions } from "@/scripts/tc-feedback-select-show-hide.js";
import { renderIndividualGraph } from "@/scripts/individual-viz.js";

export const initializeIndividualTeamCheckDetails = () => {
  initializeFeedbackAccordions();
  renderIndividualGraph();
};
